import React from 'react';

const AcquisitionBasic = ({ fumId, basic }) => {
  return (
    <div className="w-full m-0">
      <div className="w-full">
        <div className="grid grid-cols-12 gap-0">
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Liability Balance
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.liability_balance !== 'undefined' 
                ? basic.liability_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Total Amount Of Acquisition
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.total_acquisition !== 'undefined' 
                ? basic.total_acquisition.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-3 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              Acquisition Return
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {basic?.currency_symbol} {typeof basic?.acquisition_return !== 'undefined' 
                ? basic.acquisition_return.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                : 0}
            </p>
          </div>
          
          <div className="col-span-1 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              ROI
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {typeof basic?.roi !== 'undefined' ? basic.roi : 0}
            </p>
          </div>
          
          <div className="col-span-2 p-0 border border-gray-300">
            <p className="m-0 p-2 bg-gray-500 text-white text-center font-medium text-sm">
              IRR
            </p>
            <p className="m-0 p-2 bg-white text-center text-sm">
              {typeof basic?.irr !== 'undefined' ? basic.irr : 0}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcquisitionBasic;
